export interface Currency {
  country: string;
  name: string;
  code: string;
  rate: number;
}

export interface CurrencyRate {
  id: number;
  companyId: number;
  rateModel: RateModel;
  validFrom: string;
}

export enum RateModel {
  DAILY = 'Daily',
  DAILY_MINUS_ONE = 'DailyMinusOne',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
  YEARLY = 'Yearly',
}
